define('uikit/collections/tree',['require','exports','module','underscore','marionette','../mixins/component.mixin','../channel','../templates','../extra/extend.util','semantic/modules/accordion'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Templates = require('../templates');
  var ExtendUtil = require('../extra/extend.util');
  require('semantic/modules/accordion');

  var ContentViewContainer = '> .content';

  var TreeItem = Mn.CompositeView.extend(ComponentMixin).extend({
    className: 'node',

    template: Templates.UIKit['tree.item'],

    tagName: 'div',

    options: {
      selectable: true,
      selected: false,
      link: false,
      target: null,
      icon: null,
      text: '',
      disabled: false,
      isAllowed: true,
    },

    forceUpdate: {
      link: true,
      target: true,
      icon: true,
      text: true,
      isAllowed: true,
    },

    childViewContainer: ContentViewContainer,

    childViewEventPrefix: 'leaf',

    buildChildView: function(child, klass, options) {
      var options = _.extend({ model: child, forceUpdate: { isAllowed: true } }, options);
      var ChildViewWithBehavior = ExtendUtil.extendClassBehaviors(klass, { behaviors: options.behaviors });
      var view = new ChildViewWithBehavior(options);
      return view;
    },

    childViewOptions: function(model) {
      return {
        root: this.getOption('root'),
        bindings: _.clone(this.bindings),
        behaviors: model.attributes.behaviors,
      };
    },

    events: {
      'click @ui.title': 'handleTitlePress',
      'keydown @ui.title': 'handleTitleKeydown',

      'keydown @ui.expandIcon': 'handleExpandKeydown',
      'click @ui.expandIcon': 'handleExpandPress',
    },

    ui: {
      content: '> .content',
      title: '> .title',
      expandIcon: '> .title > .dropdown.icon',
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this.root = this.getOption('root');
    },

    handleTitlePress: function(ev) {
      this.handleTriggerLeafPress();
    },

    handleTitleKeydown: function(ev) {
      if (ev.keyCode == 13) {
        this.handleTriggerLeafPress();
      }
    },

    handleTriggerLeafPress: function() {
      if (this.link) {
        this.ui.title
          .find('> a')
          .get(0)
          .click();
        return;
      }

      this.root.triggerMethod('leaf:press', this);
    },

    handleExpandKeydown: function(ev) {
      if (ev.keyCode == 13) {
        ev.stopPropagation();

        this.root.triggerMethod('leaf:expand', this);
      }
    },

    handleExpandPress: function(ev) {
      ev.stopPropagation();

      this.root.triggerMethod('leaf:expand', this);
    },

    onRender: function() {
      if (!this.children.length) {
        this.ui.content.remove();
        this.ui.expandIcon.hide();
      } else {
        this.children.each(function(child) {
          if (child.isAllowed === false) {
            child.model.attributes.isAllowed = false;
          }
        });
      }
    },

    updateAttributes: function() {
      this.addClass('selected', this.getBoolOption('selected'));
      // TODO: Figure out why the links with the disabled property being added flicker upon toggling the tree menu.
      // this.addClass('disabled', this.getBoolOption('disabled'));
    },

    serializeData: function() {
      var data = ComponentMixin.serializeData.apply(this, arguments);
      if (this.link && _.isString(this.link)) {
        data.href = this.link;
      }
      return data;
    },
  });

  var Tree = Mn.CollectionView.extend(ComponentMixin).extend({
    className: 'ui tree accordion',

    childView: TreeItem,

    childViewContainer: ContentViewContainer,

    childViewOptions: function() {
      return {
        root: this,
      };
    },

    options: {
      collapsible: true,
      selected: null,
      exclusive: false,
      styled: false,
      fluid: false,
      inverted: false,
    },

    forceUpdate: { collapsible: true, exclusive: true },

    onLeafPress: function(leaf) {
      if (leaf.children.length) {
        this.toggle(leaf.ui.title);
      }
      if (this.selected === leaf.model) {
        this.selected = null;
      } else {
        this.selected = leaf.model;
      }
    },

    onLeafExpand: function(leaf) {
      if (leaf.children.length) {
        this.toggle(leaf.ui.title);
      }
    },

    findLeafByModel: function(model) {
      function findLeaf(parent) {
        // first use the native babysitter find
        // method
        var view = parent.children.findByModel(model);
        if (!view) {
          // if not view was found then we need to do the same thing on all the children
          parent.children.each(function(child) {
            if (!view) {
              // recurse through the children until we find what we need
              view = findLeaf(child);
            }
          });
        }
        return view;
      }
      return findLeaf(this);
    },

    onFirstRender: function() {
      this.on('change:selected', function(view, value, previous) {
        var previousView = null,
          transitionModule = null;

        if (previous) {
          // find the view that links to the previous model
          previousView = this.findLeafByModel(previous);
        }
        if (previousView) {
          transitionModule = previousView.$el.data().moduleTransition;
        }
        // do some bullshit because the transition module
        // restores class names...super annoying
        if (transitionModule && transitionModule.is.animating()) {
          previousView.$el.one(transitionModule.get.animationEndEvent(), function() {
            previousView.selected = false;
          });
        } else if (previousView) {
          // if we found it, then set its selected
          // state to false
          previousView.selected = false;
        }
        this._onChangeSelected();
      });

      this._onChangeSelected();
    },

    _onChangeSelected: function() {
      var selected = this.selected,
        view = null;

      if (selected) {
        view = this.findLeafByModel(selected);
      }

      if (view && view.selectable) {
        // don't select a view unless
        // it is selectable
        view.selected = true;
      }
    },

    onRender: function() {
      var options = _.extend({ selector: { trigger: '.nope' } }, this.options),
        self = this;

      _.each(
        ['opening', 'open', 'closing', 'close', 'change'],
        function(name) {
          var fnName = 'on' + name.slice(0, 1).toUpperCase() + name.slice(1);
          options[fnName] = function() {
            self.triggerMethod('accordion:' + name, self);
          };
        },
        this
      );
      this.$el.accordion(options);
    },

    open: function(index) {
      this.$el.accordion('open', index);
      return this;
    },

    close: function(index) {
      this.$el.accordion('close', index);
      return this;
    },

    toggle: function(index) {
      this.$el.accordion('toggle', index);
      return this;
    },

    updateAttributes: function() {
      this.addClass('styled', this.getBoolOption('styled'))
        .addClass('fluid', this.getBoolOption('fluid'))
        .addClass('inverted', this.getBoolOption('inverted'));
    },
  });

  // Register the Tree Component
  channel.reply('tree', function() {
    return Tree;
  });

  module.exports = Tree;
});

